// eslint-disable-next-line import/prefer-default-export
export const formatPostMessage = (message) => {
  const entityMap = {
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
  };

  let html = message || "";

  html = html.replace(/[<>"']/g, (s) => entityMap[s]);

  // URLs starting with http://, https://, or ftp://
  const urlPatternProtocol =
    /(\b)((https?|ftp):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gi;
  html = html.replace(
    urlPatternProtocol,
    '$1<a class="link" href="$2" target="_blank" rel="nofollow noreferrer noopener">$2</a>'
  );

  // URLs starting with "www." (without // before it, or it'd re-link the ones done above).
  const urlPattern =
    /(^|\s)(www\.[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gi;
  html = html.replace(
    urlPattern,
    '$1<a class="link" href="http://$2" target="_blank" rel="nofollow noreferrer noopener">$2</a>'
  );

  // Change email addresses to mailto:: links.
  const mailPattern =
    /(\b)(([a-zA-Z0-9\-_.])+@[a-zA-Z_]+?(\.[a-zA-Z]{2,6})+)/gi;
  html = html.replace(mailPattern, '$1<a class="link" href="mailto:$2">$2</a>');

  // Hashtags
  const hashtagPattern = /(^|\s)(#[\w\p{L}]+)/giu;
  html = html.replace(hashtagPattern, '$1<a class="hashtag">$2</a>');

  // Mentions
  const mentionPattern = /(^|\s)(@[\w\p{L}]+)/giu;
  html = html.replace(mentionPattern, '$1<a class="mention">$2</a>');

  // New lines
  const newLinePattern = /(\r\n|\r|\n)/gi;
  html = html.replace(newLinePattern, "<br>");

  return html;
};
